/**
 * Feature flags — flip a single boolean here to enable/disable a feature
 * across the entire app without deleting any code.
 *
 * NEXT_SLOT_FEATURE
 * -----------------
 * Powers the "Next available slot" UI:
 *   - LiveAvailabilityStrip (thin banner at the top of every page)
 *   - NextSlotWidget (pill in homepage hero + every service page hero)
 *
 * Parked on 2026-08-25 because the underlying WriteUpp diary data was
 * returning UTC-naive strings that we were treating as UK-local. During
 * BST this shifted every appointment 1 hour behind reality, so the
 * widget was advertising "free" slots that were actually booked.
 *
 * TO RE-ENACT: flip this to `true`. When you do, also verify:
 *   1. The BST/UTC parser fix in booking_slots.py::_parse_wu_datetime
 *      is in place (naive strings must be parsed as UTC then converted).
 *   2. A turnover buffer is enforced (min 10-15 min between the offered
 *      slot and any adjacent appointment so we never advertise a slot
 *      with zero clean-up time).
 *   3. Server cache TTL is short (≤ 60s) and invalidated by the
 *      WriteUpp 5-min poll when the diary changes.
 *   4. Same-day lead time is realistic (≥ 2 hours) so we never
 *      advertise a slot patients can't actually make.
 */
export const NEXT_SLOT_FEATURE = false;
